import 'driver.js/dist/driver.css';
import './assets/fto-pro-onboarding.scss';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { FtoProOnboardingService } from './fto-pro-onboarding-service';
import { FtoProOnboardingServiceImpl } from './impls/fto-pro-onboarding-service';
import { FtoProOnboardingRuntime } from './fto-pro-onboarding-runtime';
import { FtoProOnboardingRuntimeImpl } from './impls/fto-pro-onboarding-runtime';
import { FtoProReportOnboardingService } from './fto-pro-report-onboarding-service';
import { FtoProReportOnboardingServiceImpl } from './impls/fto-pro-report-onboarding-service';

/** 注册 FTO Pro 首页首次引导相关服务。 */
export const ftoProOnboardingModule = (bind: interfaces.Bind) => {
    bind(FtoProOnboardingRuntime).to(FtoProOnboardingRuntimeImpl);
    bind(FtoProOnboardingService).to(FtoProOnboardingServiceImpl).inTransientScope();
    bind(FtoProReportOnboardingService).to(FtoProReportOnboardingServiceImpl).inSingletonScope();
};

export { FtoProOnboardingService } from './fto-pro-onboarding-service';
export { FtoProOnboardingServiceImpl } from './impls/fto-pro-onboarding-service';
export { FtoProOnboardingRuntime } from './fto-pro-onboarding-runtime';
export { FtoProOnboardingRuntimeImpl } from './impls/fto-pro-onboarding-runtime';
export { FtoProReportOnboardingService } from './fto-pro-report-onboarding-service';
export { FtoProReportOnboardingServiceImpl } from './impls/fto-pro-report-onboarding-service';
export { registerFtoProReportOnboardingDebug } from './fto-pro-report-onboarding-debug';
export type { FtoProOnboardingStartOptions } from './fto-pro-onboarding-service';
export type { FtoProReportOnboardingDebugApi } from './fto-pro-report-onboarding-debug';
